<template>
  <div>
    <b-button
      variant="danger"
      @click="showConfirmation"
      :size="iconOnly ? 'sm' : undefined"
    >
      <template v-if="iconOnly">
        <svg style="fill: currentColor;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-trash" viewBox="0 0 16 16">
          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
        </svg>
      </template>
      <span v-else>Produkt löschen</span>
    </b-button>

    <b-modal
      v-model="showModal"
      title="Löschen bestätigen"
      @ok="handleDelete"
      ok-variant="danger"
      ok-title="Löschen"
      cancel-title="Abbrechen"
    >
      <p>Sind Sie sicher, dass Sie dieses Produkt löschen möchten?</p>
      <p class="text-muted">Diese Aktion kann nicht rückgängig gemacht werden.</p>
    </b-modal>
  </div>
</template>

<script>
import products from '@/api/products';

export default {
  name: 'DeleteProductButton',
  props: {
    productId: {
      type: [String, Number],
      required: true
    },
    iconOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    showConfirmation() {
      this.showModal = true;
    },
    async handleDelete() {
      try {
        await products.deleteProduct(this.productId);
        this.$store.commit('products/removeProduct', this.productId);
        this.$emit('deleted', this.productId);
      } catch (error) {
        this.$bvToast.toast('Das Produkt konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.', {
          title: 'Fehler',
          variant: 'danger',
          solid: true
        });
        this.$emit('error', error);
      }
    }
  }
}
</script>